import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { TrendModule } from 'ngx-trend';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './home/home.component';
import { InfoComponent } from './info/info.component';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { ChartComponent } from './chart/chart.component';

const routes: Routes = [
  { path:'', redirectTo:'list', pathMatch: 'full' },
  { path:'list/:page', component: HomeComponent },
  { path:'coin/:id', component: InfoComponent },
  { path:'chart/:exchangeId/:coinId/:pairId', component: ChartComponent },
  { path: '**', component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    InfoComponent,
    ShortNumberPipe,
    ChartComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule, 
    TrendModule, 
    AppRoutingModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
